import React from 'react';
import './Sponsorship.css';
import { toSentenceCase } from '../utils/textUtils';

function Sponsorship() {
  const progress = 72;
  const target = 500; // Objectif: 500+ jeunes filles
  const donors = 135; // Nombre de donateurs
  const sponsored = 54; // Nombre de filles parrainées
  const amountRaised = 12500000; // Montant atteint en FCFA
  const amountTarget = 25000000; // Montant demandé en FCFA

  const handleNavigation = (page) => {
    if (window.navigateTo) {
      window.navigateTo(page);
      window.scrollTo(0, 0);
    }
  };

  return (
    <section className="sponsorship section">
      <div className="container">
        <div className="title-wrapper">
          <h2 className="section-title">
            <span className="title-icon">🎓</span>
            {toSentenceCase("Scolarisation gratuite des ")}
            <span className="title-highlight">{toSentenceCase("filles")}</span>
          </h2>
        </div>
        <p className="section-subtitle">
          {toSentenceCase("Un programme révolutionnaire pour garantir l'accès à l'éducation technique de qualité à toutes les jeunes filles, sans barrière financière.")}
        </p>

        <div className="sponsorship-content">
          <div className="sponsorship-image">
            <img src="/images/scolarisation-filles.jpg" alt="Élèves du CPET Les Palmiers - Scolarisation et Parrainage" />
          </div>

          <div className="sponsorship-info">
            <h3>{toSentenceCase("Objectif 2026-2027")}</h3>
            <p>
              {toSentenceCase(`Nous nous engageons à offrir une scolarisation gratuite à ${target}+ jeunes filles méritantes cette année académique, grâce au soutien de nos partenaires et donateurs.`)}
            </p>

            <div className="progress-section">
              <div className="progress-label">
                <span>{toSentenceCase("Progression")}</span>
                <span>{progress}%</span>
              </div>
              <div className="progress-bar">
                <div 
                  className="progress-fill" 
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>

            <div className="stats-row">
              <div className="stat-box">
                <div className="stat-value">{donors}</div>
                <div className="stat-label">{toSentenceCase("Donateurs")}</div>
              </div>
              <div className="stat-box">
                <div className="stat-value">{sponsored}</div>
                <div className="stat-label">{toSentenceCase("Parrainées")}</div>
              </div>
            </div>

            <div className="stats-row">
              <div className="stat-box">
                <div className="stat-value">{(amountRaised / 1000000).toFixed(1)}M</div>
                <div className="stat-label">{toSentenceCase("Montant atteint")}</div>
              </div>
              <div className="stat-box">
                <div className="stat-value">{(amountTarget / 1000000).toFixed(0)}M</div>
                <div className="stat-label">{toSentenceCase("Montant demandé")}</div>
              </div>
            </div>

            <div className="sponsorship-buttons">
              <button 
                className="btn btn-primary"
                onClick={() => handleNavigation('donation')}
              >
                {toSentenceCase("Parrainer")}
              </button>
              <button 
                className="btn btn-secondary" 
                style={{color: '#1e5ba8', borderColor: '#1e5ba8'}}
                onClick={() => handleNavigation('partner')}
              >
                {toSentenceCase("Devenir partenaire")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Sponsorship;
